import React from "react";
import { Link, Outlet } from "react-router";
import Header from "../headerDasboard/Header";

const Dashboard = () => {
  return (
    <div className="container-fluid bg-dark">
      <Header />
      <div className="row">
        <div className="col-12 col-md-12 bg-light border-end p-3 w-100">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
